/*--------------
V 1.0.0 - Criado por Larner Diogo

DESCIÇÃO:
Componente geral da aplicação


COMPONENTS
***********************************************************/
import { Component } from '@angular/core';
import { HttpService } from './globals/http';
import { GlobalService } from './globals/globals';

@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {

  constructor(
    private HttpService: HttpService,
    private GlobalService: GlobalService
  ){
    /* setInterval(() => {

      //ATUALIZANDO NOTIFICACOES
      this.GlobalService.getQtdNotificacoes();

    }, 10000); */
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts